<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";
  const license = "outreach";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <LicenseChip {style} {license} />
  <H1>Your outreach in motion</H1>
  <P>
    Keep tabs on every email going out. From follow-ups to first touches, the
    Outbox gives you full visibility and peace of mind.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-reply-clock" {...iconProps} />View and manage
      scheduled messages
    </Bullet>
    <Bullet>
      <IconScale class="fa-sliders" {...iconProps} />
      Deliverability controls minimize bouncebacks
    </Bullet>
    <Bullet>
      <IconScale class="fa-check" {...iconProps} />
      Improved efficiency, reduced errors</Bullet
    >
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/98q05e1" />
</Slide>
